import IDeviceInfo, { OperatingSystem } from '~/types/common/device-info'

// Basic device detection
function getDeviceInfo(): IDeviceInfo {
  const userAgent = navigator.userAgent.toLowerCase()
  const defaultInfo = {
    os: OperatingSystem.UNKNOWN,
    isMobile: false,
  }

  // Check if we're in a browser environment
  const isBrowser = typeof window !== 'undefined'

  // Get userAgent string
  const ua = userAgent?.toLowerCase() || (isBrowser ? window.navigator.userAgent.toLowerCase() : '')

  // If no userAgent is available, return default info
  if (!ua) {
    return defaultInfo
  }

  const isAndroid = /android/i.test(userAgent)
  const isIOS = /iphone|ipad|ipod/i.test(userAgent)
  const isWindows = /windows/i.test(userAgent)
  const isMac = /macintosh|mac os/i.test(userAgent)
  const isLinux = /linux/i.test(userAgent)

  return {
    os: isAndroid
      ? OperatingSystem.ANDROID
      : isIOS
        ? OperatingSystem.IOS
        : isWindows
          ? OperatingSystem.WINDOWS
          : isMac
            ? OperatingSystem.MACOS
            : isLinux
              ? OperatingSystem.LINUX
              : OperatingSystem.UNKNOWN,
    isMobile: isAndroid || isIOS,
  }
}

export default getDeviceInfo
